import { render } from "./TimePicker.vue?vue&type=template&id=18a137d6&scoped=true&ts=true"
import script from "./TimePicker.vue?vue&type=script&lang=ts"
export * from "./TimePicker.vue?vue&type=script&lang=ts"

import "./time-input.scss?vue&type=style&index=0&id=18a137d6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a137d6"]])

export default __exports__